// © Microsoft Corporation. All rights reserved.
import { elevation, heightNumber, neutralFillStealthHoverBehavior, neutralFillStealthRestBehavior, neutralFocusBehavior, neutralForegroundRestBehavior, neutralLayerFloatingBehavior, } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { display } from "@microsoft/fast-foundation";
export const HamburgerMenuStyles = css `
    ${display("flex")}
    :host {
        --elevation: 11;
        width: fit-content
    }

    fluent-button {
        height: calc(${heightNumber} * 1px);
        width: calc(${heightNumber} * 1px);
    }

    .button-glyph {
        fill: ${neutralForegroundRestBehavior.var};
        height: 16px;
        width: 16px;
    }

    .close-button {
        align-items: center;
        background: ${neutralLayerFloatingBehavior.var};
        display: flex;
        justify-content: center;
        justify-self: end;
    }

    .close-button:hover {
        background: ${neutralFillStealthHoverBehavior.var};
    }

    .hidden {
        display: none;
    }

    .logo {
        margin-inline-start: 24px;
        fill: ${neutralForegroundRestBehavior.var};
    }

    .menu {
        ${elevation}
        background: ${neutralLayerFloatingBehavior.var};
        display: flex;
        flex-direction: column;
        height: 100%;
        min-width: 300px;
        top: 0;
        width: fit-content;
    }

    .menu-button {
        align-items: center;
        justify-content: center;
    }

    .menu-content {
        align-self: flex-start;
        overflow-y: auto;
        width: 100%;
    }

    .menu-header {
        align-items: center;
        display: grid;
        grid-template-columns: auto auto;
        justify-content: stretch;
        padding: 20px;
    }

    .mobile {
        justify-content: flex-end;
    }

    .overlay {
        align-items: flex-start;
        background-color: transparent;
        display: flex;
        flex-direction: row;
        height: 100%;
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
        width: 100%;
    }

    .separator {
        margin: calc(var(--design-unit) * 1px) 24px;
    }

    .tree-view[hidden] {
        display: none;
    }

    .tree-view {
        align-items: stretch;
        flex-direction: column;
        font-size: 0;
        min-width: fit-content;
    }
    .tree-view:focus-visible {
        outline: none;
    }
`.withBehaviors(neutralForegroundRestBehavior, neutralFillStealthRestBehavior, neutralFocusBehavior, neutralLayerFloatingBehavior, neutralFillStealthHoverBehavior);
